'use strict';

var _ = require('underscore');

var SKILLS = [
"Actionscript",
"Ada",
"Assembly",
"Awk",
"Bash",
"C",
"C#",
"C++",
"COBOL",
"COMAL",
"CSS",
"Caml",
"Clojure",
"CoffeeScript",
"ColdFusion",
"Common Lisp",
"Coq",
"Curl",
"D",
"Dart",
"E",
"Elixir",
"Emacs Lisp",
"Erlang",
"F#",
"Forth",
"Fortran",
"GNU Octave",
"Go",
"Gosu",
"Groovy",
"HTML",
"Haskell",
"Idris",
"Io",
"Ioke",
"J",
"J#",
"Java",
"Java 8",
"JavaScript",
"Julia",
"LaTeX",
"Lisp",
"Lua",
"MATLAB",
"ML",
"Maple",
"Markdown",
"Mathematica",
"Matlab",
"Nimrod",
"Node.js",
"OCaml",
"Objective-C",
"Opa",
"OpenCL",
"PHP",
"Pascal",
"Perl",
"Prolog",
"Puppet",
"Python",
"Q",
"R",
"Racket",
"Ruby",
"Rust",
"SAS",
"SPARK",
"SPSS",
"SQR",
"Scala",
"Scheme",
"Self",
"Shell",
"Simulink",
"Smalltalk",
"Smarty",
"Standard ML",
"Swift",
"TACL",
"Tcl",
"Tex",
"Turing",
"TypeScript",
"VHDL",
"Verilog",
"VimL",
"Visual Basic",
"Visual Basic .NET",
"csh",
"sed",
"yacc",
"zsh"
];

var FRAMEWORKS = [
"AIDA/Web",
"APR",
"ASP.NET Dynamic Data",
"ASP.NET MVC Framework (ASP.NET MVC)",
"AWS",
"Abdera",
"Accumulo",
"ActiveMQ",
"Agavi",
"Aiki Framework",
"Akka",
"Allura",
"AngularJS",
"Ant",
"AppFuse",
"Archiva",
"Axis",
"Ayoola Framework",
"Banshee",
"Base One Foundation Component Library (BFC)",
"Batik",
"Beehive",
"Bloodhound",
"BlueBream",
"Brutos Framework",
"CFWheels",
"CXF",
"CakePHP",
"Camel",
"Camping",
"Cassandra",
"Catalyst",
"Cayenne",
"Celix",
"Cgiapp",
"CherryPy",
"ClanCatsFramework",
"CloudStack",
"Cocoon",
"CodeIgniter",
"ColdBox Platform",
"ColdFusion on Wheels",
"ColdSpring",
"Commons",
"Compojure",
"Continuum",
"Cordova",
"CouchDB",
"CppCMS",
"Cuba",
"CubicWeb",
"Dancer",
"Derby",
"Directory",
"Django",
"Drupal",
"Eclipse RAP",
"EmberJS",
"Excalibur",
"FOP",
"FTP server",
"Fat-Free",
"Fat-Free Framework",
"Felix",
"Flask",
"Flex",
"Flink",
"Flume",
"FormEngine",
"Forrest",
"FuelPHP",
"Fusebox",
"Geronimo",
"Google Web Toolkit",
"Gradle",
"Grails",
"Grok",
"Gump",
"HTTP Server",
"Hadoop",
"Hamlets",
"Happstack",
"Harmony",
"Hazaar MVC",
"HiveMind",
"ItsNat",
"JBoss Seam",
"JDO",
"JVx",
"JVx WebUI",
"Jackrabbit",
"Jakarta",
"James",
"JavaServer Faces",
"Joomla",
"Jspx-bay",
"Kafka",
"Kajona",
"Kepler",
"Laravel",
"Lenya",
"Lift",
"Lithium",
"Logging",
"Lucene",
"MINA",
"Mach-II",
"Mahout",
"Marmotta",
"Mason",
"Maven",
"Maypole",
"Merb",
"Model-Glue",
"Mojolicious",
"MonoRail",
"Morfik",
"Muse",
"MyFaces",
"Nagare",
"Nette Framework",
"OFBiz",
"OODT",
"Ocsigen",
"Olingo",
"Oozie",
"Opa",
"OpenACS",
"OpenJPA",
"OpenLaszlo",
"OpenNLP",
"OpenOffice",
"OpenRasta",
"OpenXava",
"Oracle ADF",
"PDFBox",
"PHPixie",
"POI",
"PRADO",
"Padrino",
"Phalcon",
"Pivot",
"Play",
"Poco",
"Portals",
"Project",
"Projectaroject",
"PureMVC",
"Pyjamas",
"Pylons",
"Pyramid",
"Qcodo",
"Qpid",
"RIFE",
"Rampart",
"React",
"Ruby on Rails",
"Saetta Web Server",
"Santuario",
"Scalatra",
"Seagull",
"Seaside",
"ServiceMix",
"Shale",
"Silex",
"SilverStripe (Sapphire)",
"Simple MVC Framework",
"Sinatra",
"Snap",
"Solodev CMS",
"Solr",
"SpamAssassin",
"Spark",
"Spring",
"SproutCore",
"Stanbol",
"Stonehenge",
"Stratos",
"Stripes",
"Struts",
"Subversion",
"Symfony",
"Symfony 2",
"TACTIC",
"TYPO3 Flow",
"Takes",
"Tapestry",
"Tcl",
"ThinWire",
"Tika",
"Tntnet",
"Tomcat",
"Tornado",
"Torque",
"Traffic Server",
"TurboGears",
"Tuscany",
"UIMA",
"VRaptor",
"Vaadin",
"Velocity",
"Wakanda",
"Wave",
"Wavemaker",
"Web services",
"WebObjects",
"WebWork",
"Webware",
"Wicket",
"Wt",
"XML",
"XMLBeans",
"Xalan",
"Xerces",
"Xyster Framework",
"Yesod",
"Yii",
"ZK",
"Ze Framework",
"Zend Framework",
"Zikula",
"Zookeeper",
"Zope 2",
"Zotonic",
"iBATIS",
"jclouds",
"log4j",
"mod_perl",
"mod_python",
"qooxdoo",
"vibe.d",
"web2py",
];

var SKILLS_AND_FRAMEWORKS = _.uniq(SKILLS.concat(FRAMEWORKS));

module.exports = {
    standard: SKILLS_AND_FRAMEWORKS,
    lowerCase: _.map(SKILLS_AND_FRAMEWORKS, function(elem) { return elem.toLowerCase(); }),
    lowerCaseMapping: _.chain(SKILLS_AND_FRAMEWORKS).map(function(elem) { return [elem.toLowerCase(), elem]; }).object().value()
};



/*****************
 ** WEBPACK FOOTER
 ** ./js/shared/utils/skills.js
 ** module id = 241
 ** module chunks = 0 1 6 9
 **/